import React from 'react'
import { Navigate, useLocation } from 'react-router-dom';
import Wrapper from '../Partials/Wrapper';
import { useSelector } from 'react-redux';

const AuthProvider = () => {


    const RequireAuth = ({ children }) => {
        const token = useSelector((state) => state.userAuth.loginInfo.token);
        let location = useLocation();
        if (!token) {
            return <Navigate to="/" state={{ from: location }} replace />;
        }
        return children;
    };
    return (
        <RequireAuth>
            <Wrapper />
        </RequireAuth>
    )
}

export default AuthProvider